import React from 'react'
import Banner from "./banner"
import ContactForm from "./contactform"
import { Helmet } from 'react-helmet';


function index() {
  return (
    <>

      <Helmet>
        <title>Get in Touch | Contact Ecom Support & Sales Team</title>
        <meta name="description" content="Have questions or need assistance? Reach out to our team for support, sales inquiries, or more information about launching your e-commerce website. We're here to help!" />
      </Helmet>
      <div className='contact'>
        <Banner />
        <ContactForm />
      </div>
    </>

  )
}

export default index